import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState } from '../../../types/types';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';
import { root } from '../../../store/constants';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';

export const authUserSetTimeZone = (
    timezone: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const authUser = getAuthUser(getState());
        const userPatch: IAuthUser = {
            id: authUser.id,
            timezone,
            region: root.App.controller.region,
            country: root.App.controller.country,
            city: root.App.controller.city,
            acceptLanguge: root.App.controller.acceptLanguge
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
